export enum IdentityVerificationStatus {
  requested = 0,
  inReview = 1,
  declined = 2,
  approved = 3,
}
